//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'addtoany-share',
  computed: {
    ...mapState({
      isMobile: state => state.browser.isMobile,
    }),
  },
  mounted() {
    if (!document.getElementById('addtoany-script')) {
      // * NOT LOADING A2A IN PRERENDER
      if (process.env.VUE_APP_PRERENDER === 'false') {
        const addtoanyScript = document.createElement('script');
        addtoanyScript.setAttribute('id', 'addtoany-script');
        addtoanyScript.setAttribute('src', 'https://static.addtoany.com/menu/page.js');
        addtoanyScript.setAttribute('async', true);
        document.head.appendChild(addtoanyScript);

        let lang = 'en-US';
        switch (this.$i18n.locale) {
          case 'ja':
            lang = 'ja-JP';
            break;
          case 'ko':
            lang = 'ko-KR';
            break;
          case 'zh-hant':
            lang = 'zh-TW';
            break;
          case 'zh-hans':
            lang = 'zh-CN';
            break;
          default:
            lang = this.$i18n.locale;
            break;
        }

        const addtoanyLang = document.createElement('script');
        addtoanyLang.type = 'text/javascript';
        addtoanyLang.text = `var a2a_config = a2a_config || {}; a2a_config.locale = '${lang}';`;
        document.head.appendChild(addtoanyLang);
      }
    } else {
      // If script already exists, reinitialize
      window.a2a.init();
    }
  },
};
